import React from 'react';
import { session_href } from './session_link';

// The session's date is its link (no separate uuid link); plain text when there is no session.
const SessionDateLink = ({ uuid, kind, className, children }) => {
  const href = session_href(uuid, kind);
  if (!href) return <span className={className}>{children}</span>;
  return (
    <a
      className={className ? `tp-link ${className}` : 'tp-link'}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={uuid}
    >
      {children}
    </a>
  );
};

export default SessionDateLink;
